import { z } from '../zod.js';
import { FLAG_ROWS } from './rows-flags.js';
export const FLAG_KEYS = Object.freeze(FLAG_ROWS.map((row) => row.key));
/** Feature flags keyed by name. Stored as the `setting` key {@link FLAGS_SETTING_KEY}. */
export const FLAGS = Object.freeze(Object.fromEntries(FLAG_ROWS.map((row) => [row.key, Object.freeze({ ...row })])));
/** The `setting.key` under which stored flag values live. */
export const FLAGS_SETTING_KEY = 'flags';
const FLAG_MODES = ['production', 'development', 'test'];
const flagShape = (optional) => Object.fromEntries(FLAG_KEYS.map((key) => [key, optional ? z.boolean().optional() : z.boolean()]));
/** Exactly one boolean per flag key; an unknown or missing key is refused. */
export const FlagsSchema = z.strictObject(flagShape(false));
/** The stored `flags` setting: any subset of the flag keys, nothing else. */
export const FlagsSettingSchema = z.strictObject(flagShape(true));
/**
 * Apply stored values over the defaults. `devDefault` applies only outside production and only
 * when no `flags` setting exists at all; a stored value always wins. Unknown keys and non-boolean
 * stored values are ignored.
 */
export function resolveFlags(setting, options) {
    if (!FLAG_MODES.includes(options.mode)) {
        throw new TypeError(`resolveFlags: unknown mode "${String(options.mode)}"`);
    }
    const noSetting = setting === undefined || setting === null;
    const useDevDefaults = noSetting && options.mode !== 'production';
    const resolved = {};
    for (const key of FLAG_KEYS) {
        const definition = FLAGS[key];
        let value = definition.default;
        if (useDevDefaults && definition.devDefault !== undefined) {
            value = definition.devDefault;
        }
        const stored = noSetting ? undefined : setting[key];
        if (typeof stored === 'boolean') {
            value = stored;
        }
        resolved[key] = value;
    }
    return Object.freeze(resolved);
}
//# sourceMappingURL=flags.js.map